import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "group-activate-sim-middle" }
const _hoisted_2 = { class: "activate-sim-middle-item" }
const _hoisted_3 = { class: "group-instruction" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "activate-sim-instruction__title" }, " Scan QR code for activation ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "list-open-instruction__warning error-text" }, " Warning! eSIM can be installed only once. If you remove eSIM from your phone you can't reinstall it again. ", -1)
const _hoisted_6 = { class: "list-open-instruction" }
const _hoisted_7 = { class: "li-kode" }
const _hoisted_8 = { class: "group-pin-puk" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "group-activate-sim-right" }
const _hoisted_11 = { class: "tarif-content" }
const _hoisted_12 = { class: "activate-sim-manual__item" }
const _hoisted_13 = { class: "pin-code" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "LPA", -1)
const _hoisted_15 = { class: "tarif-content" }
const _hoisted_16 = { class: "video-group v1" }
const _hoisted_17 = { class: "video" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "tarif-content" }
const _hoisted_20 = { class: "activate-sim-manual__item" }
const _hoisted_21 = { class: "pin-code" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "ICCID", -1)
const _hoisted_23 = { class: "tarif-content" }
const _hoisted_24 = ["innerHTML"]

import { ref, Ref } from "vue";
import QRCodeVue3 from "qrcode-vue3";
import { Esim } from "@/stores/esim";
import { copyToClipBoard } from "@/helpers";
import ActivationQr from "@/components/esim/activation/ActivationQr.vue";
import { useDataStore } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivationAndroid',
  props: {
  esim: Esim,
},
  setup(__props) {

const dataStore = useDataStore();

const manualOpened: Ref<boolean> = ref(false);
const instructionOpened: Ref<boolean> = ref(false);
const detailsOpened: Ref<boolean> = ref(false);
const termsOpened: Ref<boolean> = ref(false);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(ActivationQr, { esim: __props.esim }, null, 8, ["esim"]),
              (_unref(dataStore).activationInstructions)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: {"padding":"0 20px","word-break":"break-word"},
                    innerHTML: 
                  _unref(dataStore).activationInstructions.android.tutorial_html_text
                
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: _normalizeClass(["description-tarif-content-item", { active: manualOpened.value }])
      }, [
        _createElementVNode("h6", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (manualOpened.value = !manualOpened.value))
        }, "Manual eSIM activation"),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(`LPA:1$${__props.esim.smdpAddress}$${__props.esim.matchingId}`), 1)
            ]),
            _createElementVNode("button", {
              class: "copy-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
                _unref(copyToClipBoard)(
                  `LPA:1$${__props.esim?.smdpAddress}$${__props.esim?.matchingId}`
                )
              ))
            }, " Copy ")
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["description-tarif-content-item", { active: instructionOpened.value }])
      }, [
        _createElementVNode("h6", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (instructionOpened.value = !instructionOpened.value))
        }, " See activation tutorial "),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("iframe", {
                src: _unref(dataStore).activationInstructions.android.videoguide_link,
                frameborder: "0",
                allowfullscreen: ""
              }, null, 8, _hoisted_18)
            ])
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["description-tarif-content-item", { active: detailsOpened.value }])
      }, [
        _createElementVNode("h6", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (detailsOpened.value = !detailsOpened.value))
        }, "eSIM details"),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(__props.esim.iccid), 1)
            ]),
            _createElementVNode("button", {
              class: "copy-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(copyToClipBoard)(__props.esim?.iccid || '')))
            }, " Copy ")
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["description-tarif-content-item", { active: termsOpened.value }])
      }, [
        _createElementVNode("h6", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (termsOpened.value = !termsOpened.value))
        }, "Terms & Conditions"),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("p", {
            innerHTML: _unref(dataStore).termsText
          }, null, 8, _hoisted_24)
        ])
      ], 2)
    ])
  ]))
}
}

})